export function convertMetrics(speed,measurementSystem){
    //const measurementSystem = localStorage.getItem("measurementSystem")
      
    if (measurementSystem === "Imperial mile/hr"){
        speed = speed * 0.6213
        return ((Math.round(Number(speed) / 0.05) * 0.05).toFixed(2))
    }
    if (measurementSystem === "Imperial min/mile"){
        speed = 96.56/speed
        speed = timeConvert(speed)
        return (speed)
    }
    if (measurementSystem === "Metric min/km"){
        speed = 60/speed
        speed = timeConvert(speed)
        return (speed)
    }
    else{
        try{
            return((Math.round(Number(speed) / 0.05) * 0.05).toFixed(2))
        }
        catch(err){
            return(speed)
        }
        
    }
}

export function timeConvert(time) {
    var min = Math.floor(time)
    var sec = time % 60-Math.floor(time)
    sec = sec*60
    sec = sec.toFixed(0)
    if (sec<10){
        sec = `0${sec}`
    }
    return (min+':'+sec)
}


export function metricSpeed(measurementSystem){
    //const measurementSystem = localStorage.getItem("measurementSystem")
    if (measurementSystem === "Imperial mile/hr"){
        return ("mile/hr")
    }
    if (measurementSystem === "Imperial min/mile"){
        return ("min/mile")
    }
    if (measurementSystem === "Metric min/km"){
        return ("min/km")
    }
    else{
        return("km/hr")
    }
}

export function metricDistance(distance,measurementSystem){
    if(measurementSystem === "Imperial mile/hr" || measurementSystem === "Imperial min/mile"){
        return (distance*0.6).toFixed(2)
    }
    else{
        try{
            return distance.toFixed(2)
        }
        finally{
            return distance
        }
        
    }
}
export function metricDistanceAnalytics(distance,measurementSystem){
    if(measurementSystem === "Imperial mile/hr" || measurementSystem === "Imperial min/mile"){
        return distance*0.6
    }
    else{
        return distance
    }
}
export function metric(measurementSystem){
    if(measurementSystem === "Imperial mile/hr" || measurementSystem === "Imperial min/mile"){
        return ' miles'
    }
    else{
        return ' km'
    }
}